import * as types from './actionTypes';

export const setLanguage = (language) => ({
  type: types.SET_LANGUAGE,
  payload: {language}
});

export const setActiveTheme = (activeTheme) => ({
  type: types.SET_ACTIVE_THEME,
  payload: {activeTheme}
});

export const setAgreeEmailCheckbox = (agreeEmailCheckbox) => ({
  type: types.SET_AGREE_EMAIL_CHECKBOX,
  payload: {agreeEmailCheckbox}
});

export const setProductionSheetCheckbox = (productionSheetCheckbox) => ({
  type: types.SET_PRODUCTION_SHEET_CHECKBOX,
  payload: {productionSheetCheckbox}
});

// true when the production sheet checkbox forced prices to be shown (hideCheckoutBreakdownCost was on),
// so we know to toggle them back off when the checkbox is reverted
export const setProductionSheetChangedShowPrices = (productionSheetChangedShowPrices) => ({
  type: types.SET_PRODUCTION_SHEET_CHANGED_SHOW_PRICES,
  payload: {productionSheetChangedShowPrices}
});

export const setInitialVisualizerType = (initialVisualizerType) => ({
  type: types.SET_INITIAL_VISUALIZER_TYPE,
  payload: {initialVisualizerType}
});

export const setNetworkConnection = (networkConnection) => ({
  type: types.SET_NETWORK_CONNECTION,
  payload: {networkConnection}
});

export const setAmazonImageUrl = (amazonImageUrl) => ({
  type: types.SET_AMAZON_IMAGE_URL,
  payload: {amazonImageUrl}
});

export const setAllFeaturesLoaded = (allFeaturesWereLoaded) => ({
  type: types.SET_ALL_FEATURES_LOADED,
  payload: {allFeaturesWereLoaded}
});

export const setAllowRouting = (allowRouting) => ({
  type: types.SET_ALLOW_ROUTING,
  payload: {allowRouting}
});

export const setAllowMainLoading = (allowMainLoading) => ({
  type: types.SET_ALLOW_MAIN_LOADING,
  payload: {allowMainLoading}
});

export const setActionAfterVisualizerTypeIsChanged = (actionAfterRoomChange) => ({
  type: types.SET_ACTION_AFTER_VISUALIZER_TYPE_CHANGED,
  payload: {actionAfterRoomChange}
});

export const setVisualizerIsChanging = (visualizerIsChanging) => ({
  type: types.SET_VISUALIZER_TYPE_CHANGING,
  payload: {visualizerIsChanging}
});

export const setRoomIsSwitching = (roomIsSwitching) => ({
  type: types.SET_ROOM_IS_SWITCHING,
  payload: {roomIsSwitching}
});

export const setJobIsSaving = (jobIsSaving) => ({
  type: types.SET_JOB_IS_SAVING,
  payload: {jobIsSaving}
});
